<script>
export default {
  computed: {
    editor_botton_sheet_styles () {
      if(this.$root.bottomSheetFullscreen) {
        return {overflow: "auto"}
      }
      if(this.noActionBar) {
        return {'height': "584px", overflow: "auto"}
      }
      return {'height': "532px", overflow: "auto"}
    }
  }
}
</script>
